module.exports = __webpack_public_path__ + "media/images/pages/img_cover_left_04-641b9cda83e6624013de9b2c5dce68ee.jpg";